/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { makeStyles } from '@mui/styles';

export const useDetailsTabStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
    maxWidth: '500px',
  },
  formButtons: {
    display: 'flex',
    marginTop: '20px',
    gap: '10px',
  },
}));
